import { fetchParcColor } from "./parcActions"
import { showToast } from "./toastActions"
import { handleErrors, catchApiError } from "./apiHelpers"

// Injecté au build via REACT_APP_API_URL (cf. Docker / scripts). Fallback = IP
// LAN de dev pour `npm start` local sans variable d'env.
export const URL = process.env.REACT_APP_API_URL || "http://localhost:8000/"

// URL WebSocket dérivée de l'API (http→ws, https→wss). Sert au flux temps réel
// des notifications (cf. utilities/notificationsSocket.js).
export const WS_URL = URL.replace(/^http/, "ws")

// DEPTOLOC
export const FETCH_DEPTOLOCATION_BEGIN = "FETCH_DEPTOLOCATION_BEGIN"
export const FETCH_DEPTOLOCATION_SUCCESS = "FETCH_DEPTOLOCATION_SUCCESS"
export const FETCH_DEPTOLOCATION_ERROR = "FETCH_DEPTOLOCATION_ERROR"

export const fetchDepToLocationBegin = () => ({
	type: FETCH_DEPTOLOCATION_BEGIN,
})

export const fetchDepToLocationSuccess = (depToLocation) => ({
	type: FETCH_DEPTOLOCATION_SUCCESS,
	payload: { depToLocation },
})

export const fetchDepToLocationError = (error) => ({
	type: FETCH_DEPTOLOCATION_ERROR,
	payload: { error },
})

export function fetchDepToLocation(kwargs) {
	let url = `${URL}api/deptolocation?`
	for (let key in kwargs) url += `${key}=${kwargs[key]}&`
	url = url.substring(0, url.length - 1)
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepToLocationBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepToLocationSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDepToLocationError))
	}
}

// EMPLOYES
export const FETCH_EMPLOYES_BEGIN = "FETCH_EMPLOYES_BEGIN"
export const FETCH_EMPLOYES_SUCCESS = "FETCH_EMPLOYES_SUCCESS"
export const FETCH_EMPLOYES_ERROR = "FETCH_EMPLOYES_ERROR"

export const fetchEmployesBegin = () => ({
	type: FETCH_EMPLOYES_BEGIN,
})

export const fetchEmployesSuccess = (employes) => ({
	type: FETCH_EMPLOYES_SUCCESS,
	payload: { employes },
})

export const fetchEmployesError = (error) => ({
	type: FETCH_EMPLOYES_ERROR,
	payload: { error },
})

export function fetchEmployes() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEmployesBegin())
		return fetch(`${URL}api/employes`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchEmployesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchEmployesError))
	}
}

// APPELS
export const FETCH_APPELS_BEGIN = "FETCH_APPELS_BEGIN"
export const FETCH_APPELS_SUCCESS = "FETCH_APPELS_SUCCESS"
export const FETCH_APPELS_ERROR = "FETCH_APPELS_ERROR"

export const fetchAppelsBegin = () => ({
	type: FETCH_APPELS_BEGIN,
})

export const fetchAppelsSuccess = (appels) => ({
	type: FETCH_APPELS_SUCCESS,
	payload: { appels },
})

export const fetchAppelsError = (error) => ({
	type: FETCH_APPELS_ERROR,
	payload: { error },
})

// Le référentiel Appel a été supprimé (remplacé par appel_type + entités
// Assistance). L'action est conservée en no-op pour ne pas casser d'anciens
// imports (legacy) : elle ne fait AUCUN appel réseau (plus d'endpoint api/appels).
export function fetchAppels() {
	return async (dispatch) => {
		dispatch(fetchAppelsSuccess([]))
		return Promise.resolve()
	}
}

// DESTS
export const FETCH_DESTS_BEGIN = "FETCH_DESTS_BEGIN"
export const FETCH_DESTS_SUCCESS = "FETCH_DESTS_SUCCESS"
export const FETCH_DESTS_ERROR = "FETCH_DESTS_ERROR"

export const fetchDestsBegin = () => ({
	type: FETCH_DESTS_BEGIN,
})

export const fetchDestsSuccess = (dests) => ({
	type: FETCH_DESTS_SUCCESS,
	payload: { dests },
})

export const fetchDestsError = (error) => ({
	type: FETCH_DESTS_ERROR,
	payload: { error },
})

export function fetchDests(kwargs) {
	let url = `${URL}api/dests`
	if (kwargs) {
		url = `${url}?`
		let max = Object.keys(kwargs).length
		let i = 0
		for (let a in kwargs) {
			url = `${url}${a}=${kwargs.a}`
			if (i < max - 1) url = `${url}&`
			i++
		}
	}
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDestsBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDestsSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchDestsError))
	}
}

// DEPANNEUSES
export const FETCH_DEPVEHICULES_BEGIN = "FETCH_DEPVEHICULES_BEGIN"
export const FETCH_DEPVEHICULES_SUCCESS = "FETCH_DEPVEHICULES_SUCCESS"
export const FETCH_DEPVEHICULES_ERROR = "FETCH_DEPVEHICULES_ERROR"

export const fetchDepVehiculeBegin = () => ({
	type: FETCH_DEPVEHICULES_BEGIN,
})

export const fetchDepVehiculeSuccess = (depVehicules) => ({
	type: FETCH_DEPVEHICULES_SUCCESS,
	payload: { depVehicules },
})

export const fetchDepVehiculeError = (error) => ({
	type: FETCH_DEPVEHICULES_ERROR,
	payload: { error },
})

export function fetchDepVehicules() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepVehiculeBegin())
		return fetch(`${URL}api/depvehicules`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepVehiculeSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDepVehiculeError))
	}
}

// DEPANNAGE
export const SET_DEP = "SET_DEP"
export const FETCH_DEPANNAGE_BEGIN = "FETCH_DEPANNAGE_BEGIN"
export const FETCH_DEPANNAGE_SUCCESS = "FETCH_DEPANNAGE_SUCCESS"
export const FETCH_DEPANNAGE_ERROR = "FETCH_DEPANNAGE_ERROR"
export const FETCH_DEPANNAGE_RESET = "FETCH_DEPANNAGE_RESET"

export function setDep(dep) {
	return async (dispatch, getState) => {
		dispatch({
			type: SET_DEP,
			value: dep,
		})
		return Promise.resolve()
	}
}

export const fetchDepannageBegin = () => ({
	type: FETCH_DEPANNAGE_BEGIN,
})

export const fetchDepannageSuccess = (depannage) => ({
	type: FETCH_DEPANNAGE_SUCCESS,
	payload: { depannage },
})

export const fetchDepannageError = (error) => ({
	type: FETCH_DEPANNAGE_ERROR,
	payload: { error },
})

export const fetchDepannageReset = (dispatch) => {
	return async (dispatch) => {
		dispatch({
			type: FETCH_DEPANNAGE_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchDepannage(id = null) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepannageBegin())
		return fetch(`${URL}api/depannages?id=${id}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepannageSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDepannageError))
	}
}

export const POST_DEPANNAGE_BEGIN = "POST_DEPANNAGE_BEGIN"
export const POST_DEPANNAGE_SUCCESS = "POST_DEPANNAGE_SUCCESS"
export const POST_DEPANNAGE_ERROR = "POST_DEPANNAGE_ERROR"
export const POST_DEPANNAGE_ERRORFIELD = "POST_DEPANNAGE_ERRORFIELD"
export const POST_DEPANNAGE_RESET = "POST_DEPANNAGE_RESET"
export const POST_DEPANNAGE_FULLRESET = "POST_DEPANNAGE_FULLRESET"

export const postDepannageBegin = () => ({
	type: POST_DEPANNAGE_BEGIN,
})

export const postDepannageSuccess = (depannage) => ({
	type: POST_DEPANNAGE_SUCCESS,
	payload: { depannage },
})

export const postDepannageErrorField = (errorFields) => ({
	type: POST_DEPANNAGE_ERRORFIELD,
	payload: { errorFields },
})

export const postDepannageError = (error) => ({
	type: POST_DEPANNAGE_ERROR,
	payload: { error },
})

export const postDepannageReset = () => ({
	type: POST_DEPANNAGE_RESET,
})

export function postDepannageFullReset() {
	return async (dispatch) => {
		dispatch({
			type: POST_DEPANNAGE_FULLRESET,
		})
		return Promise.resolve()
	}
}

export function postDepannage(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDepannageBegin())
		return fetch(`${URL}api/depannages`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(postDepannageSuccess(json)))
			.then(() => dispatch(fetchParcColor()))
			.catch(catchApiError(dispatch, postDepannageError, { silent: true }))
	}
}

// POST_APPEL

export const POST_APPEL_BEGIN = "POST_APPEL_BEGIN"
export const POST_APPEL_SUCCESS = "POST_APPEL_SUCCESS"
export const POST_APPEL_ERROR = "POST_APPEL_ERROR"
export const POST_APPEL_RESET = "POST_APPEL_RESET"

export const postAppelBegin = () => ({
	type: POST_APPEL_BEGIN,
})

export const postAppelSuccess = (appels) => ({
	type: POST_APPEL_SUCCESS,
	payload: { appels },
})

export const postAppelError = (error) => ({
	type: POST_APPEL_ERROR,
	payload: { error },
})

export const postAppelReset = () => ({
	type: POST_APPEL_RESET,
})

export function postAppel(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAppelBegin())
		return fetch(`${URL}api/appels`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAppelSuccess(json))
			})
			.catch(catchApiError(dispatch, postAppelError))
	}
}

// DELETE_APPEL

export const DELETE_APPEL_BEGIN = "DELETE_APPEL_BEGIN"
export const DELETE_APPEL_SUCCESS = "DELETE_APPEL_SUCCESS"
export const DELETE_APPEL_ERROR = "DELETE_APPEL_ERROR"
export const DELETE_APPEL_RESET = "DELETE_APPEL_RESET"

export const deleteAppelBegin = () => ({
	type: DELETE_APPEL_BEGIN,
})

export const deleteAppelSuccess = (appels) => ({
	type: DELETE_APPEL_SUCCESS,
	payload: { appels },
})

export const deleteAppelError = (error) => ({
	type: DELETE_APPEL_ERROR,
	payload: { error },
})

export const deleteAppelReset = () => ({
	type: DELETE_APPEL_RESET,
})

export function deleteAppel(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteAppelBegin())
		return fetch(`${URL}api/appels`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteAppelSuccess(json)))
			.catch(catchApiError(dispatch, deleteAppelError))
	}
}

// POST_EMPLOYES

export const POST_EMPLOYES_BEGIN = "POST_EMPLOYES_BEGIN"
export const POST_EMPLOYES_SUCCESS = "POST_EMPLOYES_SUCCESS"
export const POST_EMPLOYES_ERROR = "POST_EMPLOYES_ERROR"
export const POST_EMPLOYES_RESET = "POST_EMPLOYES_RESET"

export const postEmployesBegin = () => ({
	type: POST_EMPLOYES_BEGIN,
})

export const postEmployesSuccess = (employes) => ({
	type: POST_EMPLOYES_SUCCESS,
	payload: { employes },
})

export const postEmployesError = (error) => ({
	type: POST_EMPLOYES_ERROR,
	payload: { error },
})

export const postEmployesReset = () => ({
	type: POST_EMPLOYES_RESET,
})

export function postEmployes(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEmployesBegin())
		return fetch(`${URL}api/employes`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postEmployesSuccess(json))
			})
			.catch(catchApiError(dispatch, postEmployesError))
	}
}

// Édition RH d'un employé (prénom/nom/email/actif/tels) — réutilise la
// machine d'état postEmploye (masterReducer).
export function updateEmploye(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEmployesBegin())
		return fetch(`${URL}api/rh/employe`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postEmployesSuccess(json))
				dispatch(
					showToast(
						"success",
						data.id ? "Employé modifié" : "Employé créé",
					),
				)
			})
			// silent : l'erreur s'affiche dans EmployeModalV2 (règle hybride).
			.catch(catchApiError(dispatch, postEmployesError, { silent: true }))
	}
}

// DELETE_EMPLOYE

export const DELETE_EMPLOYE_BEGIN = "DELETE_EMPLOYE_BEGIN"
export const DELETE_EMPLOYE_SUCCESS = "DELETE_EMPLOYE_SUCCESS"
export const DELETE_EMPLOYE_ERROR = "DELETE_EMPLOYE_ERROR"
export const DELETE_EMPLOYE_RESET = "DELETE_EMPLOYE_RESET"

export const deleteEmployeBegin = () => ({
	type: DELETE_EMPLOYE_BEGIN,
})

export const deleteEmployeSuccess = (employes) => ({
	type: DELETE_EMPLOYE_SUCCESS,
	payload: { employes },
})

export const deleteEmployeError = (error) => ({
	type: DELETE_EMPLOYE_ERROR,
	payload: { error },
})

export const deleteEmployeReset = () => ({
	type: DELETE_EMPLOYE_RESET,
})

export function deleteEmploye(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteEmployeBegin())
		return fetch(`${URL}api/employes`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteEmployeSuccess(json)))
			.catch(catchApiError(dispatch, deleteEmployeError))
	}
}

// Suppression RH (boss-only serveur) — réutilise la machine deleteEmploye.
export function deleteEmployeRH(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteEmployeBegin())
		return fetch(`${URL}api/rh/employe`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteEmployeSuccess(json))
				dispatch(showToast("success", "Employé supprimé"))
			})
			// silent : l'erreur s'affiche dans EmployeModalV2 (règle hybride).
			.catch(catchApiError(dispatch, deleteEmployeError, { silent: true }))
	}
}

// POST_DESTS

export const POST_DESTS_BEGIN = "POST_DESTS_BEGIN"
export const POST_DESTS_SUCCESS = "POST_DESTS_SUCCESS"
export const POST_DESTS_ERROR = "POST_DESTS_ERROR"
export const POST_DESTS_RESET = "POST_DESTS_RESET"

export const postDestsBegin = () => ({
	type: POST_DESTS_BEGIN,
})

export const postDestsSuccess = (dests) => ({
	type: POST_DESTS_SUCCESS,
	payload: { dests },
})

export const postDestsError = (error) => ({
	type: POST_DESTS_ERROR,
	payload: { error },
})

export const postDestsReset = () => ({
	type: POST_DESTS_RESET,
})

export function postDests(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDestsBegin())
		return fetch(`${URL}api/dests`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postDestsSuccess(json))
			})
			.catch(catchApiError(dispatch, postDestsError))
	}
}

// DELETE_DEST

export const DELETE_DEST_BEGIN = "DELETE_DEST_BEGIN"
export const DELETE_DEST_SUCCESS = "DELETE_DEST_SUCCESS"
export const DELETE_DEST_ERROR = "DELETE_DEST_ERROR"
export const DELETE_DEST_RESET = "DELETE_DEST_RESET"

export const deleteDestBegin = () => ({
	type: DELETE_DEST_BEGIN,
})

export const deleteDestSuccess = (dests) => ({
	type: DELETE_DEST_SUCCESS,
	payload: { dests },
})

export const deleteDestError = (error) => ({
	type: DELETE_DEST_ERROR,
	payload: { error },
})

export const deleteDestReset = () => ({
	type: DELETE_DEST_RESET,
})

export function deleteDest(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteDestBegin())
		return fetch(`${URL}api/dests`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(deleteDestSuccess(json)))
			.catch(catchApiError(dispatch, deleteDestError))
	}
}

//////////////////////////////////////////////////////////////
//                      CLIENT VEHICULES                    //
//////////////////////////////////////////////////////////////

export const FETCH_DEP_CLIENTVEHICULE_BEGIN = "FETCH_DEP_CLIENTVEHICULE_BEGIN"
export const FETCH_DEP_CLIENTVEHICULE_ERROR = "FETCH_DEP_CLIENTVEHICULE_ERROR"
export const FETCH_DEP_CLIENTVEHICULE_SUCCESS =
	"FETCH_DEP_CLIENTVEHICULE_SUCCESS"
export const FETCH_DEP_CLIENTVEHICULE_RESET = "FETCH_DEP_CLIENTVEHICULE_RESET"

export const fetchDepClientVehiculeBegin = () => ({
	type: FETCH_DEP_CLIENTVEHICULE_BEGIN,
})

export const fetchDepClientVehiculeError = (error) => ({
	type: FETCH_DEP_CLIENTVEHICULE_ERROR,
	payload: { error },
})

export const fetchDepClientVehiculeSuccess = (clientVehicule) => ({
	type: FETCH_DEP_CLIENTVEHICULE_SUCCESS,
	payload: { clientVehicule },
})

export const fetchDepClientVehiculeReset = () => ({
	type: FETCH_DEP_CLIENTVEHICULE_RESET,
})

export function fetchDepClientVehicule(plaques) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepClientVehiculeBegin())
		let url = `${URL}api/clientvehicules?plaques=${plaques}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepClientVehiculeSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDepClientVehiculeError))
	}
}

// POST_DEP_TO_ATE

export const POST_DEP_TO_ATE_BEGIN = "POST_DEP_TO_ATE_BEGIN"
export const POST_DEP_TO_ATE_SUCCESS = "POST_DEP_TO_ATE_SUCCESS"
export const POST_DEP_TO_ATE_ERROR = "POST_DEP_TO_ATE_ERROR"
export const POST_DEP_TO_ATE_RESET = "POST_DEP_TO_ATE_RESET"

export const postDepToAteBegin = () => ({
	type: POST_DEP_TO_ATE_BEGIN,
})

export const postDepToAteSuccess = (data) => ({
	type: POST_DEP_TO_ATE_SUCCESS,
	payload: { data },
})

export const postDepToAteReset = () => ({
	type: POST_DEP_TO_ATE_RESET,
})

export const postDepToAteError = (error) => ({
	type: POST_DEP_TO_ATE_ERROR,
	payload: { error },
})

export function postDepToAte(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDepToAteBegin())
		return fetch(`${URL}api/deptoatelier`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postDepToAteSuccess(json))
			})
			.catch(catchApiError(dispatch, postDepToAteError))
	}
}

// POST_DEP_MATERIEL

export const POST_DEP_MATERIEL_BEGIN = "POST_DEP_MATERIEL_BEGIN"
export const POST_DEP_MATERIEL_SUCCESS = "POST_DEP_MATERIEL_SUCCESS"
export const POST_DEP_MATERIEL_ERROR = "POST_DEP_MATERIEL_ERROR"
export const POST_DEP_MATERIEL_RESET = "POST_DEP_MATERIEL_RESET"

export const postDepMaterielBegin = () => ({
	type: POST_DEP_MATERIEL_BEGIN,
})

export const postDepMaterielSuccess = (data) => ({
	type: POST_DEP_MATERIEL_SUCCESS,
	payload: { data },
})

export const postDepMaterielReset = () => ({
	type: POST_DEP_MATERIEL_RESET,
})

export const postDepMaterielError = (error) => ({
	type: POST_DEP_MATERIEL_ERROR,
	payload: { error },
})

export function postDepMateriel(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDepMaterielBegin())
		return fetch(`${URL}api/depmateriel`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postDepMaterielSuccess(json))
			})
			.catch(catchApiError(dispatch, postDepMaterielError))
	}
}

// ERROR HANDLING — définition déplacée dans apiHelpers.js ; ré-export pour
// les nombreux fichiers d'actions qui l'importent encore d'ici.
export { handleErrors } from "./apiHelpers"

// ÉTAT DÉPANNAGE (GE-46) — page /depannage/etat + badge « À compléter ».
// `depanneurId` 0/null = tous (responsables) ; un employé est forcé à
// lui-même côté serveur quel que soit le paramètre.
export const FETCH_DEP_ETAT_BEGIN = "FETCH_DEP_ETAT_BEGIN"
export const FETCH_DEP_ETAT_SUCCESS = "FETCH_DEP_ETAT_SUCCESS"
export const FETCH_DEP_ETAT_ERROR = "FETCH_DEP_ETAT_ERROR"
export const FETCH_DEP_A_COMPLETER_COUNT_SUCCESS =
	"FETCH_DEP_A_COMPLETER_COUNT_SUCCESS"

export const fetchDepEtatBegin = (menu) => ({
	type: FETCH_DEP_ETAT_BEGIN,
	payload: { menu },
})

export const fetchDepEtatSuccess = (menu, data) => ({
	type: FETCH_DEP_ETAT_SUCCESS,
	payload: { menu, data },
})

export const fetchDepEtatError = (error) => ({
	type: FETCH_DEP_ETAT_ERROR,
	payload: { error },
})

// Id de la dernière requête lancée : une réponse plus ancienne (changement
// rapide de menu / de dépanneur) est ignorée (revue 02.10, R14).
let derniereRequeteDepEtat = 0

export function fetchDepEtat(menu, depanneurId = 0) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const requete = ++derniereRequeteDepEtat
		dispatch(fetchDepEtatBegin(menu))
		let url = `${URL}api/depannages-etat?menu=${menu}`
		if (depanneurId) url += `&depanneur_id=${depanneurId}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				if (requete !== derniereRequeteDepEtat) return
				dispatch(fetchDepEtatSuccess(menu, json))
				if (menu === "aCompleter" && !depanneurId)
					dispatch({
						type: FETCH_DEP_A_COMPLETER_COUNT_SUCCESS,
						payload: json.results.length,
					})
			})
			.catch((err) => {
				if (requete !== derniereRequeteDepEtat) return
				return catchApiError(dispatch, fetchDepEtatError)(err)
			})
	}
}

// Badge de nav : nombre de fiches à compléter dans le périmètre de
// l'utilisateur (les siennes, ou toutes pour un responsable). Silencieux.
export function fetchDepACompleterCount() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		// `compte=1` → {n} : pas de sérialisation des lignes (D7, 03.10).
		return fetch(`${URL}api/depannages-a-completer?compte=1`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: FETCH_DEP_A_COMPLETER_COUNT_SUCCESS,
					payload: json.n,
				}),
			)
			.catch(() => {})
	}
}
